import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { StripePriceAnonymous } from "@switcherstudio/switcher-api-client";
import { MaintenancePlan } from "hooks/useMaintenancePlan";
import { displayAmount } from "helpers/stripe";
import { SkeletonTextLoader } from "components/skeleton/SkeletonTextLoader";
import styles from "./index.module.scss";

export interface MaintenanceStepProps {
    plan: MaintenancePlan;
    price?: StripePriceAnonymous;
}

export const MaintenanceStep = ({ plan, price }: MaintenanceStepProps) => {
    const { t } = useTranslation();

    const monthlyAmount = useMemo(() => {
        if (isNaN(price?.Amount)) {
            return <SkeletonTextLoader width="6rem" />;
        }
        return (
            displayAmount(price.Amount, { signed: true, compact: true }) +
            "/" +
            t("misc:month")
        );
    }, [price, t]);

    return (
        <div className={styles["maintenance-step"]}>
            <p className={styles["price"]}>{monthlyAmount}</p>
            <p className={styles["copy"]}>
                {t(`subscription:maintenance-${plan}-body`)}
            </p>
        </div>
    );
};
